<template>
  <div class="soltFooter" :class="{ ios: isIOS, ipx: isIPX, ipmx: isIPMX }"  :style="{ backgroundColor: bgcolor }">
    <div class="soltFooter--view l-flex l-flex__c">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name : 'soltFooter',
  props: {
    bgcolor: {
      type   : String,
      default: 'white',
    },
  },
  data () {
    return {
      isIOS: false,
      isIPX: false,
      isIPMX: false
    };
  },
  beforeMount () {
    if ( window.mobileRuntime.isApp && ! window.mobileRuntime.isAndroid ) {
      this.isIOS = window.mobileRuntime.isIOS;
      this.isIPX = window.isIPX;
      this.isIPMX = window.isIPMX
    }
  },
};
</script>

<style lang="scss" scoped>

.soltFooter {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--footer-height, var(--nav-content-height, 44px));
  z-index: 2;

  &.ipx {
    height: calc( var(--footer-height, var(--nav-content-height, 44px)) + var(--safe-bottom) );
  }
  &.ipmx {
    height: calc( var(--footer-height, var(--nav-content-height, 44px)) + var(--safe-bottom) );
  }

  &--view {
    height: var(--footer-height, var(--nav-content-height, 44px));
  }
}
</style>
